import CHECKOUT_QUERY from './checkout-query';
import HOST_CONTACT_DETAIL_QUERY from './host-contact-detail-query';
import COMPANY_CONTACT_DETAIL_QUERY from './company-contact-detail-query';
import VALIDATED_NATIONAL_ID from './validated-national-id';
import PAY_DAMAGE_CLAIM_QUERY from './pay-damage-claim-query';
import PDC_HELP_LINK_URL from './pdc-help-link-url-query';
import INSURTECH_QUERIES from './insurtech-shopping';
const {INSURTECH_SHOPPING_QUERY, INSURTECH_WP_QUERY} = INSURTECH_QUERIES;

export default {
    CHECKOUT_QUERY,
    COMPANY_CONTACT_DETAIL_QUERY,
    HOST_CONTACT_DETAIL_QUERY,
    PAY_DAMAGE_CLAIM_QUERY,
    PDC_HELP_LINK_URL,
    VALIDATED_NATIONAL_ID,
    INSURTECH_SHOPPING_QUERY,
    INSURTECH_WP_QUERY,
};
